import { eAtlas, eAtlasFrame, eFontAsset, eUIAtlasFrame, Game } from "../../../Game";
import * as Gamee from "../../../Publisher API/Gamee/GameeWrapper";
import { RepData } from "../../../ReplayData";
import { eSprite } from "../../../Sprites";
import { AtlasUtils } from "../../../Utils/Atlas/AtlasUtils";
import { eGameEndReason, Gameplay, GameResults, TIME } from "../../Gameplay";
import { HUD } from "../HUD";



const enum eState {
    waitForClick,
    waitForTime,
    gameOver,
}



export class Results {
    static readonly WND_WIDTH = 477;
    static readonly WND_HEIGHT = 892;

    private static readonly BTN_WIDTH = 238;
    private static readonly BTN_HEIGHT = 90;

    private static readonly AUTO_END_DELAY = 5 * 1000;

    private _container: pc.Entity;
    private _score: pc.Entity;
    private _lifeScore: pc.Entity;
    private _totalScore: pc.Entity;

    private _btn: pc.Entity;
    private _btnFill: pc.Entity;

    private _remTime: number;

    private _state: eState;

    private static readonly TEXT_COLOR = new pc.Color(25 / 255, 49 / 255, 63 / 255);

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.Entity) {
        // Kontejner
        this._container = new pc.Entity("results");
        this._container.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_GROUP,
            anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
            pivot: new pc.Vec2(0.5, 0.5),
            width: Results.WND_WIDTH,
            height: Results.WND_HEIGHT
        });
        parent.addChild(this._container);

        // Pozadi okna
        let atlas = Game.getAtlas(eAtlas.ui);
        let bg = new pc.Entity();

        bg.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 1, 0.5, 1],
            pivot: [0.5, 1],
            texture: atlas.texture,
            width: Results.WND_WIDTH,
            height: 732,
            rect: AtlasUtils.getAtlasFrameRegion(atlas, eUIAtlasFrame.resWnd),
        });
        this._container.addChild(bg);

        // Celkove skore
        let font = Game.app.assets.find(eFontAsset.arc8UI, pc.eAssetType.font).id;

        this._totalScore = new pc.Entity("totScore");
        this._totalScore.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [0.5, 1, 0.5, 1],
            pivot: [0.5, 0.5],
            fontSize: 63,
            fontAsset: font,
            autoWidth: true,
            autoHeight: true,
        });
        this._totalScore.setLocalPosition(0, -648, 0);
        this._container.addChild(this._totalScore);

        // Nahrane skore
        this._score = new pc.Entity();
        this._score.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [1, 1, 1, 1],
            pivot: [1, 0],
            fontSize: 28,
            fontAsset: font,
            autoWidth: true,
            autoHeight: true,
            color: Results.TEXT_COLOR
        });
        this._score.setLocalPosition(-53, -253, 0);
        this._container.addChild(this._score);

        // Skore za zbyle zivoty
        this._lifeScore = new pc.Entity();
        this._lifeScore.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [1, 1, 1, 1],
            pivot: [1, 0],
            fontSize: 28,
            fontAsset: font,
            autoWidth: true,
            autoHeight: true,
            color: Results.TEXT_COLOR
        });
        this._lifeScore.setLocalPosition(-53, -342, 0);
        this._container.addChild(this._lifeScore);

        // Close button
        this._btn = HUD.createButton(eSprite.btnResOK, Results.BTN_WIDTH, Results.BTN_HEIGHT, new pc.Vec4(0.5, 0, 0.5, 0), new pc.Vec2(0.5, 0), this._container, new pc.Vec3(0, 0, 0));
        this._btn.button.on("click", () => {
            if (this._state == eState.waitForClick) {
                if (this._remTime < Results.AUTO_END_DELAY - 1000) {
                    this.gameOver();
                }
                else {
                    this._state = eState.waitForTime;
                }
            }
        });

        this._btnFill = new pc.Entity();
        this._btnFill.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0, 0.5, 0, 0.5],
            pivot: [0, 0.5],
            width: Results.BTN_WIDTH,
            height: Results.BTN_HEIGHT,
            texture: atlas.texture,
            rect: AtlasUtils.getAtlasFrameRegion(atlas, eUIAtlasFrame.resBtnOK + "1"),
        });
        this._btn.addChild(this._btnFill);

        this._state = eState.gameOver;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._state = eState.gameOver;
        this._container.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(res: GameResults): void {
        if (this._state == eState.gameOver) {
            this._state = eState.waitForClick;

            this._totalScore.element.text = (res.score + res.remBallCnt * Gameplay.EXTRA_BALL_SCORE).toString();
            this._score.element.text = res.score.toString();
            this._lifeScore.element.text = res.remBallCnt == 0 ? "0" : (res.remBallCnt + "x" + Gameplay.EXTRA_BALL_SCORE);

            // Odpocet do automatickeho ukonceni
            this._remTime = Results.AUTO_END_DELAY;

            // Zobrazit
            this._container.enabled = true;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state != eState.gameOver) {
            let remTime = this._remTime - TIME.deltaMs;

            if (remTime < 0)
                remTime = 0;

            this._remTime = remTime;

            if (this._state == eState.waitForClick) {
                // Velikost fill casti
                let w = Math.ceil((remTime / Results.AUTO_END_DELAY) * Results.BTN_WIDTH);
                let btnFill = this._btnFill.element;

                btnFill.width = w;
                btnFill.rect.z = w / Game.getAtlas(eAtlas.ui).texture.width;
                btnFill.rect = btnFill.rect;

                if (remTime == 0)
                    this.gameOver();
            }
            else if (remTime < Results.AUTO_END_DELAY - 1000) {
                this.gameOver();
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private gameOver(): void {
        if (this._state != eState.gameOver) {
            this._state = eState.gameOver;

            Gamee.Wrapper.gameOver(RepData.instance.data);
            //console.log(RepData.instance.data);
            //Gameplay.instance.reset();
        }
    }
}